import enilogo from "./EniLogo.svg";
import chain from "./chain.svg";
import close from "./close.svg";
import columns from "./columns.svg";
import downarrow from "./downArrow.svg";
import download from "./download.svg";
import facebook from "./facebook.svg";
import grid from "./grid.svg";
import leftarrow from "./leftArrow.svg";
import linkedin from "./linkedin.svg";
import open from "./open.svg";
import play from "./play.svg";
import rightarrow from "./rightArrow.svg";
import share from "./share.svg";
import twitter from "./twitter.svg";
import vectorleft from "./vectorLeft.svg";
import vectorright from "./vectorRight.svg";

export default {
  enilogo,
  chain,
  close,
  columns,
  downarrow,
  download,
  facebook,
  grid,
  leftarrow,
  linkedin,
  open,
  play,
  rightarrow,
  share,
  twitter,
  vectorleft,
  vectorright,
};
